import { trackPromise } from 'react-promise-tracker';
import { getInsuranceDetails } from '../../services/insruanceService';
import constants from './constants';

export const getInsuranceDetailBegin =()=> ({
    type: constants.INSURANCE_DETAIL_BEGIN
});
export const getInsuranceDetailSuccess = (data)=> ({
    type: constants.INSURANCE_DETAIL_SUCCESS,
    payload: data
});

export const getInsuranceDetailError = (error)=> ({
    type: constants.INSURANCE_DETAIL_ERROR,
    payload: error,
});
export const getInsuranceDetailCleanUp = ()=> ({
    type: constants.INSURANCE_DETAIL_CLEANUP,
});

export const getInsurances = (tenantInfo)=> {
    return dispatch=> {
        dispatch(getInsuranceDetailBegin());
        trackPromise(getInsuranceDetails(tenantInfo).then((response)=>{
            dispatch(getInsuranceDetailSuccess(response.data));
        }).catch((error)=> {
            dispatch(getInsuranceDetailError(error));
        }));
    };
};